<template>
  <section class="card-wrapper" v-if="allTerminals && allGates">
    <h2 class="go-back" @click="goBack">
      <img src="~img/Shape.png" class="go-back-icon" role="go back" />
      {{ $t('back') }}
    </h2>
    <h2 class="shop-location">
      {{ $t('shop-location') }}
    </h2>
    <strong class="select-shop">
      {{ $t('select-shop') }}
    </strong>
    <div class="filter-conditions">
      <!-- 航站楼过滤器 -->
      <div class="terminal-select-box-wrapper mobile">
        <select-box
          ref="terminal"
          :list-data="allTerminals"
          class="select-box"
          @handleListItemSelect="handleFilterSelect"
          @toggleDropDownList="terminalToggleDropDownList"
        >
          <template v-slot:default>
            <div class="select-name">{{ currentSelectTerminal }}</div>
          </template>
          <template v-slot:itemDesc="item">{{ item.item.terminal }}</template>
        </select-box>
      </div>
      <!-- 入口过滤器 -->
      <div class="terminal-select-box-wrapper">
        <select-box
          ref="gate"
          :list-data="filterGates"
          class="select-box"
          @handleListItemSelect="handleSelectSpecificGate"
          @toggleDropDownList="gateToggleDropDownList"
        >
          <template v-slot:default>
            <div class="select-name">{{ currentSelectGate }}</div>
          </template>
          <template v-slot:itemDesc="item">{{ item.item }}</template>
        </select-box>
      </div>
    </div>

    <!-- 零售店列表 -->
    <section class="retail-list" v-show="retailInfo.length >= 1">
      <div
        class="retail-item"
        v-for="(item, index) in retailInfo"
        :key="index"
        @click="handleView(item)"
      >
        <h3 class="retail-name">{{ item.name }}</h3>
        <strong class="opeartion-times">{{ item.businessHours }}</strong>
        <div class="retail-info">
          <img class="retailLocationIcon" src="~img/retailLocation.png" alt="retailLocation" />
          <div class="retail-desc">
            {{ item.terminal }}<br />
            <div v-if="item.travelType">{{ item.travelType }}<br /></div>
            <div v-if="item.region">{{ item.region }}<br /></div>
            <div v-if="item.inspection">{{ item.inspection }}<br /></div>
            <div v-if="item.boardingGate">
              {{ $t('near-boarding-gate') }}: {{ item.boardingGate }}<br />
            </div>
            <div v-if="item.locationGuide">{{ item.locationGuide }}</div>
          </div>
        </div>
      </div>
    </section>
    <section v-show="retailInfo.length < 1" class="no-match-items">
      {{ $t('no-match-items') }}
    </section>
    <!-- <pdf-dialog
      :isShowPDFTitle="false"
      :showPdfModal="showPdfModal"
      :pdfUrl="pdfUrl"
      @pdfShow="handleView"
    ></pdf-dialog> -->
    <!-- PDF视图弹窗 -->
    <PDFModal v-model:open="showPdfModal" :pdfUrl="pdfUrl" />
  </section>
</template>

<script>
  import SelectBox from '@/components/BaseUi/SelectBox';
  import { mapState } from 'vuex';
  // import PdfDialog from '@/components/PDF';
  import PDFModal from './PDFModal.vue';

  export default {
    data() {
      return {
        showPdfModal: false,
        pdfUrl: new Blob(),
        // 所有航站楼下的所有入口，下拉列表的数据
        allGates: [],
        // 某个航站楼下的所有入口，下拉列表的数据
        filterGates: [],
        // 所有航站楼
        allTerminals: [],
        // 零售店信息列表
        retailInfo: [],
        // 当前选择的航站楼
        currentSelectTerminal: '',
        // 当前选择的入口
        currentSelectGate: '',
        // 当前选择了航站楼或者入口下拉列表，一个为true的话，另外一个应该为false（需求：两个列表只展示一个，不会同时展示多个）
        isSelectTerminal: true,
        isSelectGate: true,
        // 当前选择了航站楼或者入口，为true的时候展示下拉列表
        isShowTerminalDropDownList: false,
        isShowGateDropDownList: false,
      };
    },
    created() {
      this.getRetailTerminalAndGate();
    },
    methods: {
      handleView(data) {
        if (!this.isLogin) {
          // this.$loginModal.show();
          sessionStorage.setItem('afterLoginRouter', this.$route.fullPath);
          this.$router.push('/login');
          return;
        }

        if (data) {
          this.goToRetailPDF(data);
        }
      },
      goToRetailPDF(item) {
        this.$http.lounge
          .retailPDF({
            userId: this.userInfo.userId,
            sessionId: this.userInfo.sessionId,
            lang: localStorage.getItem('lang'),
            airportCode: this.retailAirportCode,
            retailCode: item.code,
          })
          .then(res => {
            this.pdfUrl = res;
            this.showPdfModal = true;
          });
      },
      goBack() {
        this.$router.go(-1);
      },
      terminalToggleDropDownList() {
        this.$refs.gate.showdropDownList = false;
      },
      gateToggleDropDownList() {
        this.$refs.terminal.showdropDownList = false;
      },
      // 获取航站楼和入口过滤器列表
      async getRetailTerminalAndGate() {
        try {
          const data = {
            lang: this.$i18n.locale,
            airportCode: this.$route.params.airportCode || this.retailAirportCode,
            codes: this.$route.params.codes || this.retailCodes,
            userId: this.userInfo?.userId,
            sessionId: this.userInfo?.sessionId,
          };
          const res = await this.$http.lounge.getRetailTerminalAndGate(data);
          // 所有的入口，包括特殊的ALL
          this.allGates = res.data.gates;
          // 首次进入页面展示的是ALL这个gates，ALL是有特殊意义的，而不是一个gate
          this.currentSelectGate = this.allGates[0];
          // 所有的航站楼，包括特殊的ALL terminals
          this.allTerminals = res.data.terminals;
          // 首次进入页面过滤的数据为所有航站楼的入口
          const res2 = await this.$http.lounge.getRetailInfoByFilter({
            lang: this.$i18n.locale,
            retailCodes: this.$route.params.codes || this.retailCodes,
            condition: JSON.stringify({ Terminal: [this.allTerminals[0].terminal] }),
            userId: this.userInfo?.userId,
            sessionId: this.userInfo?.sessionId,
          });
          // 默认选择第一个航站楼（ALL terminal）
          this.currentSelectTerminal = this.allTerminals[0].terminal;
          // 此处的retailInfo为全量的入口
          this.retailInfo = res2.list;
        } catch {
          this.$messageModal.issueApi(this.getRetailTerminalAndGate);
        }
      },
      handleFilterSelect(item) {
        this.getRetailInfoByFilter(item[1]);
        this.isShowTerminalDropDownList = !this.isShowTerminalDropDownList;
      },
      // 选择过滤条件后，展示当前航站楼下零售店信息
      async getRetailInfoByFilter(terminal) {
        try {
          // 选择过滤条件后，航站楼应该更新
          // console.log('currentSelectTerminal', this.currentSelectTerminal)
          this.currentSelectTerminal = this.allTerminals[terminal].terminal;

          // 如果不是选择第一个terminal( ALL terminal) 则入口需要做过滤
          if (terminal !== 0) {
            // 选择过滤条件后，入口列表应该剩余的数据
            this.filterGates = this.allGates.filter(item => {
              return this.allTerminals[terminal].gate.split(',').includes(item);
            });
          } else this.filterGates = this.allGates;
          // console.log('allGates', this.allGates)
          // console.log('filterGates', this.allTerminals[terminal].gate.split(','))

          this.currentSelectGate = this.filterGates[0];
          // 选择过滤条件后，展示当前航站楼下零售店信息
          const res = await this.$http.lounge.getRetailInfoByFilter({
            lang: this.$i18n.locale,
            retailCodes: this.$route.params.codes || this.retailCodes,
            condition: JSON.stringify({
              Terminal: [this.currentSelectTerminal],
              Gate: [this.currentSelectGate],
            }),
            userId: this.userInfo?.userId,
            sessionId: this.userInfo?.sessionId,
          });
          // 此处的retailInfo为选择特定航站楼下面的入口列表
          this.retailInfo = res.list;
          // console.log('retailInfo', this.retailInfo)
          // console.log('allTerminals', this.allTerminals)
        } catch (e) {
          console.log(e);
        }
      },
      // 点击入口进行零售店搜索
      handleSelectSpecificGate(gate) {
        this.isShowGateDropDownList = !this.isShowGateDropDownList;
        this.currentSelectGate = this.filterGates[gate[1]];
        this.$http.lounge
          .getRetailInfoByFilter({
            lang: this.$i18n.locale,
            retailCodes: this.$route.params.codes || this.retailCodes,
            condition: JSON.stringify({ Gate: [this.currentSelectGate] }),
            userId: this.userInfo?.userId,
            sessionId: this.userInfo?.sessionId,
          })
          .then(res => {
            this.retailInfo = res.list;
          })
          .catch(err => {
            console.log(err);
          });
      },
    },
    computed: {
      ...mapState(['retailAirportCode', 'retailCodes', 'userInfo', 'isLogin']),
    },
    watch: {
      allGates: {
        handler(newVal) {
          this.filterGates = newVal;
        },
      },
    },
    components: {
      SelectBox,
      // PdfDialog,
      PDFModal,
    },
  };
</script>

<style lang="scss" scoped>
  @use 'index.scss';
</style>
